import { createAction, props } from '@ngrx/store';
import { FilterList } from '../../pages/stats/stats-list/models/filter-list.model';

export const LIST_SET_PANEL_FILTERS =
  '[STATEMENTS] Set statements filters';

export const setListFilters = createAction(
  LIST_SET_PANEL_FILTERS,
  props<{ listFilters: FilterList }>()
);
